import { Navigate, useLocation } from "react-router-dom";
import { getStorage } from "../utils/storage";
import { routerList } from "./route_list";
import { PublicRoutes } from "./public_routes";
import { ProtectRoutes } from "./protected_routes";

const loggedIn = getStorage("user_session");

let list = routerList.map((route) => {
  // If route has children → it is a layout route
  if (route.children) {
    return {
      ...route,
      element: route.private ? (
        <ProtectRoutes showHeader={route?.header ?? 1}>
          <route.element />
        </ProtectRoutes>
      ) : (
        <PublicRoutes restrictedAfterLogin={route.restrictedAfterLogin}>
          <route.element />
        </PublicRoutes>
      ),
      children: route.children.map((child) => ({
        ...child,
        element: <child.element />
      }))
    };
  }

  // Normal route — not layout
  return {
    ...route,
    element: route.private ? (
      <ProtectRoutes showHeader={route?.header ?? 1}>
        <route.element />
      </ProtectRoutes>
    ) : (
      <PublicRoutes restrictedAfterLogin={route.restrictedAfterLogin}>
        <route.element />
      </PublicRoutes>
    ),
  };
});


const QueryPreservingNavigate = ({ to, replace = false }) => {
  const location = useLocation();
  const queryParams = location.search; // Extract query params
  return <Navigate to={`${to}${queryParams}`} replace={replace} />;
};

const routes = [
  {
    path: "/",
    element: <QueryPreservingNavigate to={loggedIn ? "/home" : "/login"} replace />,
  },
  ...list, // Render public and private routes
  {
    path: "*",
    element: <QueryPreservingNavigate to={loggedIn ? "/home" : "/login"} replace />,
  },
];

export default routes;
